import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import App from "./App";
import { I18nProvider } from "./i18n/I18nProvider";
import { ErrorBoundary } from "./components/ErrorBoundary";
import "./styles/globals.css";

const tree = (
  <React.StrictMode>
    <ErrorBoundary>
      <HelmetProvider>
        <BrowserRouter>
          <I18nProvider>
            <App />
          </I18nProvider>
        </BrowserRouter>
      </HelmetProvider>
    </ErrorBoundary>
  </React.StrictMode>
);

const rootEl = document.getElementById("root")!;
const norm = (p: string) => (p.length > 1 ? p.replace(/\/+$/, "") : p);
const prerenderedPath = rootEl.getAttribute("data-prerendered");

if (prerenderedPath !== null && norm(prerenderedPath) === norm(window.location.pathname)) {
  hydrateRoot(rootEl, tree);
} else {
  rootEl.innerHTML = "";
  createRoot(rootEl).render(tree);
}
